import React, { useCallback, useContext, useEffect, useState } from "react";
import Trainers from "../../../CommonComponents/Trainers";
import SettingsRightHeader from "./SettingsRightHeader";
import Button from "../../../Button";
import useAxiosPrivate from "../../../../Hooks/useAxiosPrivate";
import AlertContext from "../../../../context/AlertContext";
import { useParams } from "react-router-dom";
import constants from "../../../../constants";
import { tpoEmailBody } from "../../../../util";
import UserDetails from "../Users/UserDetails";
import Modal from "../../../CommonComponents/Modal";
import ModalBody from "../../../CommonComponents/ModalBody";
import { WarningFeatureIcon } from "./BatchTrainers";
import useCommonFunctionHooks from "../../../../Hooks/useCommonFunctionHooks";

const Clients = () => {
  const { id } = useParams();
  const axios = useAxiosPrivate();
  const { setIsLoaded, setShowNotify } = useContext(AlertContext);
  const [clients, setClients] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [userInput, setUserInput] = useState({});
  const [addUser, setAddUser] = useState(false);
  const useCommonFunctionHks = useCommonFunctionHooks();
  const Alert = useContext(AlertContext)
  const [openModal, setOpenModal] = useState(false);
  const [clientId, setClientId] = useState(null);

  const fetchClients = useCallback(async () => {
    try {
      setIsLoaded(true);
      let response = await axios.get(
        `node/admin/batch/${id}/users/${constants.Roles.hr}`,
        {
          headers: {
            "Content-type": "application/json",
          },
        }
      );
      if (response.data.resultCode === 1000) {
        if (response.data.data !== null) {
          let res = response.data.data;
          setClients(res);
        }
      } else
        setShowNotify({
          show: true,
          title: "Error !",
          msg: "Something went wrong. Please try again later or contact gradious team.",
        });
    } catch (error) {
      console.log("error in while fetch trainers", error);
      if (error.message.includes("403")) {
        setShowNotify({
          show: true,
          title: "Warning !",
          msg: "You have been logged-out due to inactivity. Login again.",
          isUnAuth: true,
        });
      } else
        setShowNotify({
          show: true,
          title: "Error !",
          msg: "Something went wrong. Please try again later or contact gradious team.",
        });
    } finally {
      setIsLoaded(false);
    }
  }, [axios, setShowNotify, id, setIsLoaded]);

  useEffect(() => {
    fetchClients();
  }, [fetchClients]);

  const onCloseModal = (event) => {
    event.preventDefault();
    setOpenModal(false);
    setClientId(null);
  };

  const removeClients = async (userId) => {
    if (userId) {
      setOpenModal(true);
      setClientId(userId.userid);
    }else {
      setShowNotify({
        title: "Warning !",
        msg: "Sorry!. Unable to find the trainer. please contact gradious team",
        show: true,
      });
    }
  };

   const editTrainer = (data) => {
        axios
          .get(
            "node/admin/batch/user/" + data?.userid,
            useCommonFunctionHks.getHeaderDetailsForAxios()
          )
          .then((res) => {
            if (res.data.resultCode === 1000 && res.data.data != null) {
              let topics = res.data.data?.topics ? typeof res.data.data?.topics == "string" ? JSON.parse(res.data.data?.topics) : res.data.data?.topics : [];
              let userDetails = { ...res.data.data};
              userDetails.topics = topics;
              setUserInput(userDetails);
              setShowForm(true);
              Alert.setFromTrainer(res.data.data?.role === constants.Roles.hr ? false : true);
              Alert.setIsEditTC(true);
              // setShowUserFormPopup(true);
            } else {
              Alert.setShowNotify({
                show: true,
                title: "Warning",
                msg: "No User Exists!",
              });
            }
          })
          .catch((error) => {
            useCommonFunctionHks.getCatchBlockDetails(error);
          });
    }

  const onRemoveClients = async () => {
    setIsLoaded(true);
    try {
      let res = await axios.post(
        "node/admin/batch/users/status",
        JSON.stringify({
          userIds: [clientId],
          active: false,
          batchId: id,
          removeClient: true,
        }),
        { headers: { "Content-type": "application/json" } }
      );

      if (res.data.resultCode === constants.RESULT_STATUS.SUCCESS) {
        setShowNotify({
          show: true,
          title: "Info",
          msg: "The client removed from the batch",
        });
        setClients(res.data.data);
        setOpenModal(false);
        setClientId(null);
      } else {
        setShowNotify({
          show: true,
          title: "Warning !",
          msg: res.data.message,
        });
      }
    } catch (error) {
      setIsLoaded(false);
      if (error.message.includes("403")) {
        setShowNotify({
          show: true,
          title: "Warning !",
          msg: "You have been logged-out due to inactivity. Login again.",
          isUnAuth: true,
        });
      } else
        setShowNotify({
          show: true,
          title: "Error !",
          msg: "Something went wrong. Please try again later or contact gradious team.",
        });
    } finally {
      setIsLoaded(false);
    }
  };

  const onAddClient = (event) => {
    event.preventDefault();
    setShowForm(true);
    setUserInput({
      emailBody: tpoEmailBody,
      batchid: parseInt(id),
      role: "hr",
    });
  };

  return (
    <div className="clientsContainer batchTrainersContainer">
      <SettingsRightHeader
        title="TPO / HR Users"
        titleIcon={
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M16 21V19C16 17.9391 15.5786 16.9217 14.8284 16.1716C14.0783 15.4214 13.0609 15 12 15H5C3.93913 15 2.92172 15.4214 2.17157 16.1716C1.42143 16.9217 1 17.9391 1 19V21M20 8V14M23 11H17M12.5 7C12.5 9.20914 10.7091 11 8.5 11C6.29086 11 4.5 9.20914 4.5 7C4.5 4.79086 6.29086 3 8.5 3C10.7091 3 12.5 4.79086 12.5 7Z"
              stroke="#344054"
              strokeWidth="1.6"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        }
        button={
          <Button
            size="sm"
            hierarchy={{ type: "secondaryGrey", buttonText: "Add TPO / HR" }}
            icon={{
              icon: (
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M10.0001 4.16666V15.8333M4.16675 10H15.8334"
                    stroke="#344054"
                    strokeWidth="1.67"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              ),
              type: "leading",
            }}
            onClick={onAddClient}
          />
        }
      />
      <div className="clientsSec batchTrainersSec">
        <Trainers
          trainerData={clients}
          client={true}
           icons={[
            {
              icon: (
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M2.5 5.00001H4.16667M4.16667 5.00001H17.5M4.16667 5.00001V16.6667C4.16667 17.1087 4.34226 17.5326 4.65482 17.8452C4.96738 18.1577 5.39131 18.3333 5.83333 18.3333H14.1667C14.6087 18.3333 15.0326 18.1577 15.3452 17.8452C15.6577 17.5326 15.8333 17.1087 15.8333 16.6667V5.00001H4.16667ZM6.66667 5.00001V3.33334C6.66667 2.89131 6.84226 2.46739 7.15482 2.15483C7.46738 1.84227 7.89131 1.66667 8.33333 1.66667H11.6667C12.1087 1.66667 12.5326 1.84227 12.8452 2.15483C13.1577 2.46739 13.3333 2.89131 13.3333 3.33334V5.00001"
                    stroke="#667085"
                    strokeWidth="1.66667"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              ),
              onClick: removeClients,
              tooltip: "Delete",
            },
            {
              icon: (
                <svg
                  width="20"
                  height="20"
                  fill="none"
                  viewBox="0 0 20 20"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g clipPath="url(#clip0_6374_11614)">
                    <path
                      strokeWidth="1.6"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M9.1665 3.33333H3.33317C2.89114 3.33333 2.46722 3.50893 2.15466 3.82149C1.8421 4.13405 1.6665 4.55797 1.6665 5V16.6667C1.6665 17.1087 1.8421 17.5326 2.15466 17.8452C2.46722 18.1577 2.89114 18.3333 3.33317 18.3333H14.9998C15.4419 18.3333 15.8658 18.1577 16.1783 17.8452C16.4909 17.5326 16.6665 17.1087 16.6665 16.6667V10.8333M15.4165 2.08333C15.748 1.75181 16.1977 1.56557 16.6665 1.56557C17.1353 1.56557 17.585 1.75181 17.9165 2.08333C18.248 2.41485 18.4343 2.86449 18.4343 3.33333C18.4343 3.80217 18.248 4.25181 17.9165 4.58333L9.99984 12.5L6.6665 13.3333L7.49984 10L15.4165 2.08333Z"
                      stroke={"#667085"}
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_6374_11614">
                      <rect width="20" height="20" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
              ),
              onClick: editTrainer,
              tooltip: "Edit",
            },
          ]}
        />
      </div>
      {showForm && (
        <UserDetails
          showUserFormPopup={showForm}
          newUserInput={userInput}
          setNewUserInput={setUserInput}
          setShowUserFormPopup={setShowForm}
          refetch={fetchClients}
          addUser={addUser} 
          setAddUser={setAddUser}
        />
      )}
      {openModal && (
        <Modal isOpen={openModal} onClose={onCloseModal} showCloseIcon={false} className="batchTrainerModal">
          <ModalBody
            header={WarningFeatureIcon}
            content={
              <>
                <p className="contentTitle">Remove Client</p>
                <p className="content">
                  Are you sure you want to remove the client from the batch?
                </p>
              </>
            }
            footer={
              <>
                <Button
                  size="lg"
                  hierarchy={{ type: "secondaryGrey", buttonText: "Cancel" }}
                  onClick={onCloseModal}
                />
                <Button
                  size="lg"
                  hierarchy={{
                    type: "primary",
                    buttonText: "Remove",
                  }}
                  onClick={onRemoveClients}
                  destructive={true}
                />
              </>
            }
          />
        </Modal>
      )}
    </div>
  );
};

export default Clients;
